export default "__VITE_ASSET__DqNnpuK5__"